import * as apiService from './api-service';
import {getSteemConfig} from '../config';
import { IUser } from 'interfaces/proposals/user';

export async function getUser(name: string): Promise<any> {
  let result: any;

  await apiService.post({
    url: `${getSteemConfig()}`,
    body: {
      method: "call",
      id: 0,
      params: [
        "condenser_api",
        "get_accounts",
        [[name]]
      ]
    }
  })
    .then(response => {
      if (response !== undefined) { 
        result = response[0];
      }
    })
    .catch(() => {
      return [];
    })
  return result;
}; 
export async function getUserProposalVotes(name: string): Promise<IUser> {
  let result: IUser;

  await apiService.post({
    url: `${getSteemConfig()}`,
    body: {
      method: "call",
      id: 0,
      params: [
        "condenser_api",
        "list_proposal_votes",
        [[name, 0], 1000, "by_voter_proposal"]
      ]
    }
  })
    .then(response => {
      if (response !== undefined) {
        let voterProposals = response.filter(
          p => p.voter === name
        );
        let newproposals = [];
        voterProposals.forEach(p => {
          newproposals.push(p.proposal.proposal_id);
        });
        result = {
          name: name,
          signedIn: false,
          voterProposals: newproposals
        };
      }
    })
    .catch(() => {
      return [];
    })
  return result;
}; 
export async function getUserFollowingList(username: string): Promise<any> {
  let allFollowing: any[] = [];
  let startFrom = null;
  let keepGoing = true;

  while (keepGoing) {
    const response = await apiService.post({
      url: `${getSteemConfig()}`,
      body: {
        method: "call",
        id: 0,
        params: [
          "condenser_api",
          "get_following",
          [username, startFrom, "blog", 1000]
        ]
      }
    });

    if (response && response.length > 0) { 
      const sliced = startFrom ? response.slice(1) : response;
      allFollowing = [...allFollowing, ...sliced];
      if (response.length < 1000) {
        keepGoing = false;
      } else {
        startFrom = response[response.length - 1].following;
      }
    } else {
      keepGoing = false;
    }
  }

  return allFollowing;
}
export async function getUserFollowersList(username: string): Promise<any> {
  let allFollowers: any[] = [];
  let startFrom = null;
  let keepGoing = true;

  while (keepGoing) {
    const response = await apiService.post({
      url: `${getSteemConfig()}`,
      body: {
        method: "call",
        id: 0,
        params: [
          "condenser_api",
          "get_followers",
          [username, startFrom, "blog", 1000]
        ]
      }
    });

    if (response && response.length > 0) { 
      const sliced = startFrom ? response.slice(1) : response;
      allFollowers = [...allFollowers, ...sliced];
      if (response.length < 1000) {
        keepGoing = false;
      } else {
        startFrom = response[response.length - 1].follower;
      }
    } else {
      keepGoing = false;
    }
  }

  return allFollowers;
}
export async function getUserCommunitiesList(username: string): Promise<any> { 
  const response = await apiService.post({
    url: `${getSteemConfig()}`,
    body: {
      method: "bridge.list_all_subscriptions",
      id: 2,
      params: {"account":username} 
    }
  }); 

  return response;
}